<div class="material-list-container">
  @if (tableIsLoading) {
    <div class="material-list-spinner-container">
      <app-loading-spinner></app-loading-spinner>
    </div>
  }
  @if (!tableIsLoading) {
    <div class="material-list-wrapper">
      @if (showTitle) {
        <div class="section-heading">Material List</div>
      }
      @if (showBtnAdd) {
        <div class="add-material-btn-wrapper">
          <app-excel-upload
            (validMaterialsEmitter)="addExcelMaterials($event)"
            [disabled]="hasMoreMaterialsThanNumberOfMaterialsConfig()"
            [materialsItemsLength]="materialsItems.length"
            [maxNumberOfMaterials]="maxNumberOfMaterials"
          [supplyingPackingPlantCode]="supplyingPackingPlantCode"></app-excel-upload>
          <button (click)="add()"
            [disabled]="hasMoreMaterialsThanNumberOfMaterialsConfig()"
            class="btn-primary add-material"
            data-cy="material-list-button-add"
            type="button">Add Material
          </button>
        </div>
      }
      <div class="wrapper-table-gradient">
        <table #tableRef [ngClass]="{'extended': showExtraColumns}" class="list-table" data-cy="material-list">
          <thead>
            <tr class="list-row" data-cy="material-list-header-row">
              <th [ngClass]="{'no-width-column': !enableMaterialDetailView}"
              class="list-header-element-button"></th>
              @if (showExtraColumns) {
                <th class="list-header-element dynamic material-list-small-column">
                  <app-tooltip message="Sales No">Sales
                    No
                  </app-tooltip>
                </th>
              }
              <th class="list-header-element dynamic material-list-big-column">
                <app-tooltip message="Material">
                  Material
                </app-tooltip>
              </th>
              <th class="list-header-element numeric dynamic material-list-small-column">
                <app-tooltip message="Ordered Quantity">
                  Ordered Quantity
                </app-tooltip>
              </th>
              <th class="list-header-element dynamic material-list-small-column">
                <app-tooltip message="Model type">
                  Model type
                </app-tooltip>
              </th>
              <th class="list-header-element numeric dynamic material-list-small-column">
                <app-tooltip message="LOT No">
                  LOT No
                </app-tooltip>
              </th>
              <th class="list-header-element numeric dynamic material-list-small-column">
                <app-tooltip message="MCDR No">
                  MCDR No
                </app-tooltip>
              </th>
              <th class="list-header-element dynamic material-list-small-column">
                <app-tooltip message="IGEF No">
                  IGEF No
                </app-tooltip>
              </th>
              <th class="list-header-element dynamic material-list-small-column">
                <app-tooltip message="Colour code">
                  Colour code
                </app-tooltip>
              </th>
              @if (showExtraColumns) {
                <th class="list-header-element numeric dynamic material-list-small-column">
                  <app-tooltip message="Sent Quantity">
                    Sent Quantity
                  </app-tooltip>
                </th>
                <th class="list-header-element numeric dynamic material-list-small-column">
                  <app-tooltip message="Open Quantity">
                    Open Quantity
                  </app-tooltip>
                </th>
                <th class="list-header-element dynamic material-list-small-column">
                  <app-tooltip message="Status">
                    Status
                  </app-tooltip>
                </th>
                <th class="list-header-element no-separator dynamic material-list-medium-column">
                  <app-tooltip message="Alerts">
                    Alerts
                  </app-tooltip>
                </th>
              }
              <th class="list-header-element-context-menu"></th>
            </tr>
          </thead>
          <tbody>
            @for (material of materialsItems?.slice(0, maxElements); track trackByIndex(index, material); let index = $index) {
              <tr>
                <td class="material-list-element-overlay-cell">
                  @if (showMaterialOverlay(material)) {
                    <div
                      [ngClass]="{'material-list-element-overlay-position-canceled' : material.canceled, 'material-list-element-overlay-position-material-inactive' : !material.detail?.material?.active}"
                      class="material-list-element-overlay"
                      data-cy="material-list-element-action">
                      @if (canDelete(material.detail)) {
                        <app-generic-overlay
                          (firstButtonEvent)="cancelOverlayInProgress(material)"
                          (secondButtonEvent)="delete(index)">
                        </app-generic-overlay>
                      }
                      @if (canCancel(material)) {
                        <app-generic-overlay
                          (firstButtonEvent)="cancelOverlayInProgress(material)"
                          (secondButtonEvent)="cancelMaterial(material)"
                          [secondButtonTitle]=CANCEL_MATERIAL_BUTTON_LABEL>
                        </app-generic-overlay>
                      }
                      @if (material.canceled) {
                        <div
                          class="material-list-element-overlay-inner canceled"
                          data-cy="material-list-element-canceled">
                          <p data-cy="material-list-element-overlay-text-canceled" class="material-list-element-canceled-text">
                            Material order will be cancelled
                          after saving changes</p>
                        </div>
                      }
                    </div>
                  }
                </td>
              </tr>
              <tr [ngClass]="{'list-row-exceeds-max-size': index >= maxElements - 1, 'is-open': material.isOpen}"
                class="list-row material-list-row"
                data-cy="material-list-row"
                id="material-list-{{material.detail.material.number}}-{{material.detail.position}}">
                @if (material.errorMessage) {
                  <app-table-row-overlay [message]="material.errorMessage"></app-table-row-overlay>
                }
                @if (showViewMoreOverlay(index)) {
                  <app-table-row-overlay
                  overlayClass="wrapper-table-gradient-row"></app-table-row-overlay>
                }
                <td [ngClass]="{'no-width-column': !enableMaterialDetailView}" class="list-element-button">
                  @if (enableMaterialDetailView) {
                    <div (click)="accordionChangeState(material)"
                                     [ngClass]="{'accordion-btn': toggleMaterialDetailButton(material),
                                                 'accordion-btn-disable': !toggleMaterialDetailButton(material),
                                                 'arrow-button': true}" data-cy="material-list-row-arrow-button">
                      <app-tooltip [disable]="!toggleMaterialDetailButton(material)"
                        [dynamic]="false"
                        class="display-inline-flex"
                        message="Material quick view">
                                        <span [ngClass]="{'iwp-icon-gen_arrow_right': !material.isOpen,
                                                          'iwp-icon-gen_arrow_down': material.isOpen}">
                        </span>
                      </app-tooltip>
                    </div>
                  }
                </td>
                @if (showExtraColumns) {
                  <td class="list-element dynamic">
                    <app-tooltip
                      message="{{material.detail.salesOrderNumber | undefinedValue}}">
                      <span data-cy="material-list-element-salesNumber">{{material.detail.salesOrderNumber | undefinedValue}}</span>
                    </app-tooltip>
                  </td>
                }
                <td class="list-element dynamic">
                  <app-tooltip [alignContent]="TooltipAlignmentEnum.LEFT"
                    [alignIcon]="TooltipAlignmentEnum.LEFT"
                    [disable]="!showMaterialWarningTooltip(material.detail) || !showTooltipWarnings"
                    [iconSize]="TooltipIconSizeEnum.MEDIUM"
                    [message]="getMaterialWarningTooltipLabel(material.detail)"
                    [tooltipType]="TooltipEnum.WARNING">
                    <app-tooltip
                      message="{{material.detail.material.number}} {{material.detail.material.description}}">
                      <span data-cy="material-list-element-material">{{material.detail.material.number}} {{material.detail.material.description}}</span>
                    </app-tooltip>
                  </app-tooltip>
                </td>
                @if (!material.detail.orderedQuantity) {
                  <td class="list-element dynamic">
                    <app-warning-inline [ngClass]="{'required-fields-with-menu': showCtxMenu}"
                      [warningInlineLabel]="REQUIRED_FOR_SEND_LABEL"
                      [warningType]="WarningInlineEnum.WARNING_SEND"
                    class="required-for-send"></app-warning-inline>
                  </td>
                }
                @if (material.detail.orderedQuantity) {
                  <td class="list-element dynamic">
                    <app-tooltip [alignIcon]="TooltipAlignmentEnum.LEFT"
                      [disable]="disableOrderQuantityErrorTooltip(material)"
                      [message]="getOrderQuantityErrorTooltip(material)"
                      [tooltipType]="TooltipEnum.ERROR"
                      class="display-inline-flex">
                      <app-tooltip
                        message="{{material.detail.orderedQuantity + ' ' + material.detail.material.salesUnit}}">
                        <span [ngClass]="{'error-text': !disableOrderQuantityErrorTooltip(material)}"
                        data-cy="material-list-element-orderedQuantity">{{material.detail.orderedQuantity + ' ' + material.detail.material.salesUnit}}</span>
                      </app-tooltip>
                    </app-tooltip>
                  </td>
                }
                <td class="list-element dynamic">
                  <app-tooltip
                    message="{{material.detail.modelType | undefinedValue}}">
                    <span data-cy="material-list-element-modelType">{{material.detail.modelType | undefinedValue}}</span>
                  </app-tooltip>
                </td>
                <td class="list-element numeric dynamic">
                  <app-tooltip
                    message="{{material.detail.lotNumber | undefinedValue}}">
                    <span data-cy="material-list-element-lotNumber">{{material.detail.lotNumber | undefinedValue}}</span>
                  </app-tooltip>
                </td>
                <td class="list-element numeric dynamic">
                  <app-tooltip
                    message="{{material.detail.mcdrNumber | undefinedValue}}">
                    <span data-cy="material-list-element-mcdrNumber">{{material.detail.mcdrNumber | undefinedValue}}</span>
                  </app-tooltip>
                </td>
                <td class="list-element dynamic">
                  <app-tooltip
                    message="{{material.detail.igefNumber | undefinedValue}}">
                    <span data-cy="material-list-element-igefNumber">{{material.detail.igefNumber | undefinedValue}}</span>
                  </app-tooltip>
                </td>
                <td class="list-element dynamic">
                  <app-tooltip
                    message="{{material.detail.colourCode | undefinedValue}}">
                    <span data-cy="material-list-element-colourCode">{{material.detail.colourCode | undefinedValue}}</span>
                  </app-tooltip>
                </td>
                @if (showExtraColumns) {
                  <td class="list-element numeric dynamic">
                    <app-tooltip
                      message="{{material.detail.orderedQuantity + ' ' + material.detail.material.salesUnit}}">
                      <span data-cy="material-list-element-sentQuantity">{{material.detail.sentQuantity | undefinedValue}}{{' ' + material.detail.material.salesUnit}}</span>
                    </app-tooltip>
                  </td>
                  <td class="list-element numeric dynamic">
                    <app-tooltip
                      message="{{material.detail.orderedQuantity + ' ' + material.detail.material.salesUnit}}">
                      <span data-cy="material-list-element-openQuantity">{{material.detail.openQuantity | undefinedValue}}{{' ' + material.detail.material.salesUnit}}</span>
                    </app-tooltip>
                  </td>
                  <td class="list-element dynamic">
                    <app-tooltip
                      message="{{material.detail.status.description}}">
                      <app-status-dot
                      [ngClass]="['status', material.detail.status.code]"></app-status-dot>
                      <span class="material-list-element-status"
                      data-cy="material-list-element-status">{{material.detail.status.description}}</span>
                    </app-tooltip>
                  </td>
                  <td class="list-element dynamic material-list-alerts">
                    <app-tooltip [disable]="!hasMaterialAlerts(material.detail)"
                      [message]="getMaterialAlertsTooltip(material.detail)"
                      [orderedList]="false">
                      @if (hasMaterialAlerts(material.detail)) {
                        <span>
                          <app-status-dot [ngClass]="['status', 'DEFAULT']"></app-status-dot>
                        </span>
                      }
                      <span [ngClass]="{'material-list-element-status': material.detail.alerts}"
                        data-cy="material-list-element-alerts">{{getMaterialAlertsText(
                      material.detail) | undefinedValue}}</span>
                    </app-tooltip>
                  </td>
                }
                <td class="list-element material-context-menu">
                  @if (showCtxMenu) {
                    <div class="context-menu" data-cy="material-list-element-menu" ngbDropdown>
                      <app-tooltip [dynamic]="false" class="display-inline-flex"
                        message="Material actions">
                        <span (click)="undoAll()" [ngClass]="{'disable': !isAllowed(material.detail)}"
                          class="iwp-icon-gen_kontextmenu"
                        ngbDropdownToggle></span>
                      </app-tooltip>
                      @if (isAllowed(material.detail)) {
                        <div ngbDropdownMenu>
                          @if (canEdit(material.detail)) {
                            <div (click)="edit(material)"
                              data-cy="material-list-element-menu-edit"
                              ngbDropdownItem>Edit
                            </div>
                          }
                          @if (canDelete(material.detail)) {
                            <div (click)="overlayInProgress(material)"
                              data-cy="material-list-element-menu-delete"
                              ngbDropdownItem>Delete
                            </div>
                          }
                          @if (canCancel(material)) {
                            <div (click)="overlayInProgress(material)"
                              data-cy="material-list-element-menu-cancel-order"
                              ngbDropdownItem>Cancel Order
                            </div>
                          }
                        </div>
                      }
                      @if (material.canceled) {
                        <div class="undo-context-menu" ngbDropdownMenu>
                          <div (click)="undoCancelMaterial(material)" data-cy="material-list-element-menu-undo-cancel"
                            ngbDropdownItem>Undo Cancel Order
                          </div>
                        </div>
                      }
                    </div>
                  }
                </td>
              </tr>
              <tr>
                <td [attr.colspan]="colspan">
                  <div [ngClass]="{'reduce-padding': material.detail.alerts != null}"
                    [ngbCollapse]="!material.isOpen"
                    class="accordion-materials-list"
                    data-cy="material-list-deliveries-detail">
                    @for (alert of material.detail.alerts; track alert) {
                      <div>
                        <app-status-dot [ngClass]="['status', 'DEFAULT']"></app-status-dot>
                        <span class="material-list-element-status"
                        data-cy="accordion-materials-list-alerts">{{alert.message | undefinedValue}}</span>
                      </div>
                    }
                    <app-material-list-detail [materialDeliveries]="material.detail.deliveries"
                      [materialUnits]="material.detail.material.salesUnit"
                      [transportDocument]="$safeNavigationMigration(transportDocumentType?.name)">
                    </app-material-list-detail>
                  </div>
                </td>
              </tr>
            }
          </tbody>
        </table>
        @if (showViewMore()) {
          <div class="list-view-more" data-cy="material-list-view-more">
            <button (click)="viewMore()" class="btn-text-link"><span class="text">View More</span></button>
          </div>
        }
        @if (modalIsLoading) {
          <div class="spinner-container" data-cy="material-modal-spinner-container">
            <app-loading-spinner></app-loading-spinner>
          </div>
        }
      </div>
      @if (!materialsItems || materialsItems.length === 0) {
        <div class="list-empty">
          <div class="list-empty-icon"><span class="iwp-icon-iwp_task"></span></div>
          <div class="list-empty-description">The material list is empty</div>
        </div>
      }
    </div>
  }
</div>
